/**
 * @generated SignedSource<<e3b6a5e45763ff9e497ae8d52c6941eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicCollectionPageQuery$variables = {
  after?: string | null | undefined;
  collectionRelatedTopicsQueueName: string;
  collectionSmartQueueName: string;
  entityId: string;
  first?: number | null | undefined;
};
export type topicCollectionPageQuery$data = {
  readonly collection: {
    readonly advertZone: string | null | undefined;
    readonly entityId: string;
    readonly entityUuid: string;
    readonly urlAlias: string;
    readonly " $fragmentSpreads": FragmentRefs<"hooksUseDynamicMetaTags" | "topicCollectionAdsCollection" | "topicCollectionDescriptionTopic" | "topicCollectionHeaderCollection" | "topicCollectionRestContentsCollection" | "topicCollectionSeoCollection" | "topicCollectionTopContentsCollection">;
  };
  readonly collectionRelatedTopicsQueue: {
    readonly items: {
      readonly " $fragmentSpreads": FragmentRefs<"topicCollectionHeaderRelatedLinksConnection">;
    } | null | undefined;
  } | null | undefined;
  readonly collectionSmartQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityUuid?: string;
          readonly " $fragmentSpreads": FragmentRefs<"homeSecondaryContentItemContent" | "sectionTopLeadPrimaryContentItemContent" | "topStoriesItemContent">;
        };
      }>;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"topicCollectionPageQueue">;
  } | null | undefined;
};
export type topicCollectionPageQuery = {
  response: topicCollectionPageQuery$data;
  variables: topicCollectionPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "collectionRelatedTopicsQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "collectionSmartQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityId",
        "variableName": "entityId"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "version",
      "value": 2
    }
  ],
  "kind": "ScalarField",
  "name": "advertZone",
  "storageKey": "advertZone(version:2)"
},
v6 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "collectionRelatedTopicsQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v8 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "collectionSmartQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v9 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v17/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v21 = [
  (v20/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": (v15/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v15/*: any*/),
      "storageKey": null
    },
    (v17/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v17/*: any*/)
  ],
  "storageKey": null
},
v24 = [
  (v2/*: any*/),
  (v17/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v24/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentSection",
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v17/*: any*/)
  ],
  "storageKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": [
    (v27/*: any*/),
    (v28/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v30 = [
  (v2/*: any*/)
],
v31 = {
  "kind": "InlineFragment",
  "selections": (v30/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v32 = {
  "kind": "InlineFragment",
  "selections": (v30/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v17/*: any*/)
  ],
  "storageKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    (v33/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v35 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v10/*: any*/),
            (v31/*: any*/),
            (v18/*: any*/),
            (v32/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v34/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v36 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "disableFollow",
    "storageKey": null
  }
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v38 = {
  "alias": "size1200x800",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "1200x800"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1200x800\"})"
},
v39 = {
  "alias": "size540x360",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "540x360"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": "style(filter:{\"style\":\"540x360\"})"
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v41 = [
  (v40/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v31/*: any*/),
        (v32/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesShortLabel",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "topicCollectionPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Collection",
        "kind": "LinkedField",
        "name": "collection",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topicCollectionSeoCollection"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topicCollectionHeaderCollection"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topicCollectionAdsCollection"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "hooksUseDynamicMetaTags"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topicCollectionTopContentsCollection"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topicCollectionRestContentsCollection"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topicCollectionDescriptionTopic"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "collectionRelatedTopicsQueue",
        "args": (v6/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "topicCollectionHeaderRelatedLinksConnection"
              }
            ],
            "storageKey": "items(first:10)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "collectionSmartQueue",
        "args": (v8/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "kind": "FragmentSpread",
            "name": "topicCollectionPageQueue"
          },
          {
            "alias": "items",
            "args": null,
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "__topicCollectionPage__items_connection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "homeSecondaryContentItemContent"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "sectionTopLeadPrimaryContentItemContent"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "topStoriesItemContent"
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "topicCollectionPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Collection",
        "kind": "LinkedField",
        "name": "collection",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v13/*: any*/),
          (v16/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "KeyValuePair",
                "kind": "LinkedField",
                "name": "metatags",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "DynamicMetaTags",
            "abstractKey": "__isDynamicMetaTags"
          },
          (v17/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "collectionRelatedTopicsQueue",
        "args": (v6/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v4/*: any*/)
                        ],
                        "type": "Topic",
                        "abstractKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:10)"
          },
          (v17/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "collectionSmartQueue",
        "args": (v8/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v2/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Sponsor",
                                "kind": "LinkedField",
                                "name": "sponsor",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": (v21/*: any*/),
                                    "storageKey": null
                                  },
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v17/*: any*/),
                              (v22/*: any*/),
                              (v4/*: any*/),
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shortName",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v3/*: any*/),
                                  (v23/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v29/*: any*/),
                                  (v35/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v36/*: any*/),
                                    "type": "Author",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v36/*: any*/),
                                    "type": "Topic",
                                    "abstractKey": null
                                  }
                                ],
                                "type": "BaseWithApplicationAndUrlAlias",
                                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "updatedDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "publishedDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "readingTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "headline",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              (v37/*: any*/),
                              (v19/*: any*/),
                              (v38/*: any*/),
                              (v39/*: any*/),
                              {
                                "alias": "landscape250x99",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "landscape_250_99"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "socialHeadline",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "flag",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionSegmentV2",
                            "kind": "LinkedField",
                            "name": "sectionsV2",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isSectionUnion"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v13/*: any*/),
                                      (v22/*: any*/)
                                    ],
                                    "type": "Section",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v13/*: any*/)
                                    ],
                                    "type": "VideoSection",
                                    "abstractKey": null
                                  },
                                  (v18/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v2/*: any*/),
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v23/*: any*/),
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v29/*: any*/),
                                      (v35/*: any*/)
                                    ],
                                    "type": "BaseWithApplicationAndUrlAlias",
                                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormattedValue",
                            "kind": "LinkedField",
                            "name": "subHeadline",
                            "plural": false,
                            "selections": (v41/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormattedValue",
                            "kind": "LinkedField",
                            "name": "summary",
                            "plural": false,
                            "selections": [
                              (v40/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shortUrl",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v23/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v29/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v42/*: any*/),
                                  (v34/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "BaseWithApplicationAndUrlAlias",
                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v33/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v43/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Article",
                                "kind": "LinkedField",
                                "name": "seriesContainer",
                                "plural": false,
                                "selections": [
                                  (v43/*: any*/),
                                  (v17/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v10/*: any*/),
                                      (v2/*: any*/),
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v23/*: any*/),
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v29/*: any*/),
                                      (v35/*: any*/)
                                    ],
                                    "type": "BaseWithApplicationAndUrlAlias",
                                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sponsorType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "commentCount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormattedValue",
                                "kind": "LinkedField",
                                "name": "multimediaEmbed",
                                "plural": false,
                                "selections": (v41/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleTypeSegment",
                                "kind": "LinkedField",
                                "name": "types",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleType",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v17/*: any*/),
                                      (v13/*: any*/),
                                      (v16/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasVideoContent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Author",
                                "kind": "LinkedField",
                                "name": "authors",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "types",
                                    "storageKey": null
                                  },
                                  (v17/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "leadingSlides",
                                "plural": true,
                                "selections": [
                                  (v20/*: any*/),
                                  (v37/*: any*/),
                                  (v19/*: any*/),
                                  (v38/*: any*/),
                                  (v39/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v42/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "youtubeId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "duration",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SectionSegmentV2",
                                "kind": "LinkedField",
                                "name": "sectionsV2",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v32/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Video",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "topicCollectionPage__items",
            "kind": "LinkedHandle",
            "name": "items"
          },
          (v17/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d661c87d21e20bdb26b3e3c9631a4485",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "collectionSmartQueue",
            "items"
          ]
        }
      ]
    },
    "name": "topicCollectionPageQuery",
    "operationKind": "query",
    "text": "query topicCollectionPageQuery(\n  $after: String\n  $collectionRelatedTopicsQueueName: String!\n  $collectionSmartQueueName: String!\n  $entityId: String!\n  $first: Int\n) {\n  collection(filter: {entityId: $entityId}) {\n    entityId\n    entityUuid\n    urlAlias\n    advertZone(version: 2)\n    ...topicCollectionSeoCollection\n    ...topicCollectionHeaderCollection\n    ...topicCollectionAdsCollection\n    ...hooksUseDynamicMetaTags\n    ...topicCollectionTopContentsCollection\n    ...topicCollectionRestContentsCollection\n    ...topicCollectionDescriptionTopic\n    id\n  }\n  collectionRelatedTopicsQueue: queue(filter: {name: $collectionRelatedTopicsQueueName}) {\n    items(first: 10) {\n      ...topicCollectionHeaderRelatedLinksConnection\n    }\n    id\n  }\n  collectionSmartQueue: queue(filter: {name: $collectionSmartQueueName}) {\n    ...topicCollectionPageQueue_2HEEH6\n    items(after: $after, first: $first) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityUuid\n            ...homeSecondaryContentItemContent\n            ...sectionTopLeadPrimaryContentItemContent\n            ...topStoriesItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentCoverImageContent_1SslBT on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n  ... on Article {\n    leadingSlides {\n      url\n      title\n      type\n      size1200x800: style(filter: {style: \"1200x800\"}) {\n        url\n      }\n      size540x360: style(filter: {style: \"540x360\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment contentCoverImageContent_2ihLSb on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_34Njms on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        relatedNewsletters {\n          ...helpersMassageToNewsletterItemNewsletter\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...hooksInlinePlusWidgetContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentSectionsContent on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment contentSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    ...entityLink\n    seriesContainer {\n      ...entityLink\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n  ... on Video {\n    youtubeId\n  }\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment entityFollowButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment followButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...entityFollowButtonBase\n  entityId\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckHasSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    seriesContainer {\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on SectionUnion {\n  __isSectionUnion: __typename\n  ... on Section {\n    name\n  }\n  ... on VideoSection {\n    name\n  }\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment homePrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_3LgACx\n}\n\nfragment homeSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_1uhIyn\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_1uhIyn on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2ihLSb\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2gnGW2 on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3LgACx on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_1SslBT\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksUseDynamicMetaTags on DynamicMetaTags {\n  __isDynamicMetaTags: __typename\n  metatags {\n    key\n    value\n  }\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  publishedDate\n}\n\nfragment sectionTopLeadPrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  topics {\n    ...followButtonBase\n    id\n  }\n  ...entityLink\n  ...contentCoverImageContent_34Njms\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_2gnGW2\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment topStoriesItemContent on Content {\n  __isContent: __typename\n  ...homePrimaryContentItemContent\n  ...homeSecondaryContentItemContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment topicCollectionAdsCollection on Collection {\n  entityId\n  advertZone(version: 2)\n}\n\nfragment topicCollectionDescriptionTopic on Collection {\n  name\n  description {\n    text\n  }\n}\n\nfragment topicCollectionHeaderCollection on Collection {\n  name\n}\n\nfragment topicCollectionHeaderRelatedLinksConnection on QueueItemConnection {\n  edges {\n    node {\n      __typename\n      ... on Topic {\n        name\n        urlAlias\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment topicCollectionPageQueue_2HEEH6 on Queue {\n  items(after: $after, first: $first) {\n    edges {\n      node {\n        __typename\n        ... on Content {\n          __isContent: __typename\n          entityUuid\n          ...homeSecondaryContentItemContent\n          ...sectionTopLeadPrimaryContentItemContent\n          ...topStoriesItemContent\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment topicCollectionRestContentsCollection on Collection {\n  entityId\n  advertZone(version: 2)\n}\n\nfragment topicCollectionSeoCollection on Collection {\n  name\n  description {\n    text\n  }\n  urlAlias\n  ...hooksUseDynamicMetaTags\n}\n\nfragment topicCollectionTopContentsCollection on Collection {\n  entityId\n  advertZone(version: 2)\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "709000d9e9dc2b51708ea7008176a513";

export default node;
